/**
 * The garden's forecast and readings, from WeatherContext.
 *
 * A hook rather than useContext at each call, so a component outside its
 * provider fails at once with a sentence saying so.
 *
 * @module useWeatherContext
 */

import { useContext } from 'react';
import { WeatherContext, WeatherContextType } from '../context/WeatherContextDefinition';

/**
 * The WeatherProvider's value.
 *
 * @returns The forecast and its loading state.
 * @throws Error if used outside of WeatherProvider.
 */
export function useWeatherContext(): WeatherContextType {
  const context = useContext(WeatherContext);
  if (context === undefined) {
    throw new Error('useWeatherContext must be used within a WeatherProvider');
  }
  return context;
} 